/*       */

import { gql } from '@apollo/client';

export default gql`
    query designerHookActionQuery($id: ID!) {
        result: entity(type: "system_hook_action", id: $id) {
            id
            name
            description
            primary
            modifiedDate
            createdDate
            createdBy {
                id
                name
            }
            modifiedBy {
                id
                name
            }
        }
        role: resourcePermission(type: "system_hook_action", id: $id)
    }
`;
